/** @format */

import {useEffect, useState} from 'react';

import {Trans} from 'react-i18next';

import Breadcrumbs from 'components/Breadcrumbs';

import {ROUTES} from 'constants/ROUTES';

interface Props {
  name?: string;
}

const DigitalCastBreadcrumbs = ({name}: Props) => {
  const [projectName, setProjectName] = useState<string>('');

  useEffect(() => {
    if (name) {
      setProjectName(name);
    }
  }, [name]);

  const breadcrumbs = [
    {
      href: ROUTES.INDEX,
      title: <Trans>Проекты</Trans>,
    },
    {
      href: `/${ROUTES.HOME}`,
      title: projectName,
    },
    {
      href: '',
      title: <Trans>Цифровой слепок</Trans>,
    },
  ];

  return <Breadcrumbs items={breadcrumbs} />;
};

export default DigitalCastBreadcrumbs;
